import { render } from "./NotificationEmail.vue?vue&type=template&id=05fd5da6&scoped=true"
import script from "./NotificationEmail.vue?vue&type=script&lang=js"
export * from "./NotificationEmail.vue?vue&type=script&lang=js"

import "./NotificationEmail.vue?vue&type=style&index=0&id=05fd5da6&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05fd5da6"]])

export default __exports__